import { render, staticRenderFns } from "./StepPriceDialog.vue?vue&type=template&id=54655558&scoped=true&"
import script from "./StepPriceDialog.vue?vue&type=script&lang=js&"
export * from "./StepPriceDialog.vue?vue&type=script&lang=js&"
import style0 from "./StepPriceDialog.vue?vue&type=style&index=0&id=54655558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54655558",
  null
  
)

export default component.exports